<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          v-model="entry.itemId"
          v-bind="getObject('itemId')"
          label="Item"          
          :items="availableItemsForCropping"
          item-value="id"
          item-text="name"
          @input="selectItem"
          :hint="entry.item ? ( 'Unidade de Produção: ' + entry.item.unit.name + (entry.item.brand ? ', Marca: ' + entry.item.brand.name : '')) : ''"
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>Unidade de Produção: {{data.item.unit.name}} {{data.item.brand ? ', Marca: ' + data.item.brand.name : ''}}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          :disabled="!entry.itemId || readOnly"
          v-model="entry.packagingId"
          v-bind="getObject('packagingId')"
          label="Embalagem"
          :items="packagingList"
          item-value="id"
          item-text="name"
          @input="selectPackaging(true)"
          :loading="packagingListLoading"
          autocomplete="off"
        >
          <!-- <template v-slot:append-outer>
            <PackagingNew
              :inlineAddButton="true"
              @entry-created="packagingCreated"
            />
          </template> -->
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" v-if="extraData.accountContext.allStorages">
        <v-autocomplete
          v-model="entry.storageId"
          v-bind="getObject('storageId')"
          label="Estoque"
          :items="extraData.accountContext.allStorages || extraData.accountContext.allGreenhouses"
          item-value="id"
          item-text="name"
          @input="selectStorage"
          :hint="entry.storage ? 'Localização: ' + (entry.storage.location ? entry.storage.location : 'não informada') : '' "
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>Localização: {{data.item.location ? data.item.location : 'não informada'}}</v-list-item-subtitle>
            </v-list-item-content>
          </template>

           <template v-slot:append-outer>
            <StorageNew
              :inlineAddButton="true"
              @entry-created="storageCreated"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" v-if="extraData.accountContext.allGreenhouses">
        <v-autocomplete
          v-model="entry.storageId"
          v-bind="getObject('storageId')"
          label="Estufa"
          :items="extraData.accountContext.allGreenhouses"
          item-value="id"
          item-text="name"
          @input="selectStorage"
          :hint="entry.storage ? 'Localização: ' + (entry.storage.location ? entry.storage.location : 'não informada') : '' "
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>Localização: {{data.item.location ? data.item.location : 'não informada'}}</v-list-item-subtitle>
            </v-list-item-content>
          </template>

           <template v-slot:append-outer>
            <StorageNew
              :inlineAddButton="true"
              @entry-created="storageCreated"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" v-if="availablePlantLots.plantLots && availablePlantLots.plantLots.length > 0 && this.extraData.accountContext.availableSeedlingsForCroppingInSeedPlotOperation">
        <EntryMovementItemLotsIndex
          :lotItems="entry.entryMovementItemLotsAttributes"
          :packaging="entry.packaging"
          :inputData.sync="entry.entryMovementItemLotsAttributes"
          :itemLots="availablePlantLots.plantLots"
          :readOnly="readOnly"
          :seedPlotOperation="seedPlotOperation"
          :hasTableTitle="true"
          :addAndEdit="true"
        />
      </v-col>

      <v-col cols="12" v-if="availablePlantLots.plantLots && availablePlantLots.plantLots.length > 0 && !this.extraData.accountContext.availableSeedlingsForCroppingInSeedPlotOperation">
        <EntryMovementItemLotsIndex
          :lotItems="entry.entryMovementItemLotsAttributes"
          :packaging="entry.packaging"
          :inputData.sync="entry.entryMovementItemLotsAttributes"
          :itemLots="availablePlantLots.plantLots"
          :executionOperation="executionOperation"
          :readOnly="readOnly"
          :hasTableTitle="true"
          :addAndEdit="true"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          :inputData.sync="packagingQuantity"
          mask-type="currency_10d"
          label="Quantidade de Embalagens Produzidas"
          :disabled="!entry.packagingId || readOnly"
          @update:inputData="changePackagingQuantity"
          autocomplete="off"
          :suffix="entry.packaging ? entry.packaging.text : ''"
          :key="packagingQuantityKey + 'packagingQuantity'"
        />
        <!--   -->
      </v-col>

      <v-col cols="10" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('quantity')"
          :inputData.sync="entry.quantity"
          mask-type="currency"
          label="Quantidade Unitária Produzida"
          :suffix="entry.item ? entry.item.unit.name : ''"
          :disabled="!entry.packagingId || readOnly"
          autocomplete="off"
          :hint="entry.item ? ((entry.item.cropLimit && entry.item.cropLimit >= 0) ? 'O limite máximo de colheita é de ' + numberToDecimal(entry.item.cropLimit) + ' Unid.': '') : ''"
          persistent-hint
          :key="quantityKey + 'quantity'"
          @update:inputData="changeQuantity"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MultiSelect from "@shared_components/multi_select.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue"
import EntryMovementItemLotsIndex from "@models/produced_products/produced_product_lots/index.vue";
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      endProductsList: [],
      endProductsListLoading: false,
      packagingListLoading: false,
      packagingList: [],
      renderComponent: true,
      pageLoading: false,
      packagingQuantity: 0,
      packagingQuantityKey: 0,
      quantity: 0,
      quantityKey: 0,
      availablePlantLots: {},
    }
  },
  props: {
    entry: Object,
    extraData: Object,
    isEdit: {
      type: Boolean,
      default: false
    },
    originalEntry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    seedPlotOperation: {
      type: Object,
      default: ()=>{},
    },
    executionOperation: {
      type: Object,
      default: ()=>{},
    },
    modelNameSingular: String,
  },
  components: {
    MultiSelect: MultiSelect,
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    EntryMovementItemLotsIndex: EntryMovementItemLotsIndex,
  },
  beforeCreate: function () {
    this.$options.components.StorageNew = require('@models/storages/new.vue').default
    // console.log("before", this.entry);
    // this.entry.entryMovementItemLotsAttributes = JSON.parse(JSON.stringify(this.originalEntry.entryMovementItemLotsAttributes));
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log("consumed item", this.entry.item)
    if (this.entry.item) {
      this.selectItem();
    }
    // console.log("entry", this.entry);
    // console.log("entryOr", this.originalEntry);
  },
  mounted() {
  },
  computed: {
    availableItemsForCropping: function(){
      return this.extraData.accountContext.availableEndProductsForCroppingInExecutionOperation || this.extraData.accountContext.availableSeedlingsForCroppingInSeedPlotOperation;
    }
  },
  watch: {
    "entry.entryMovementItemLotsAttributes": {
      handler: function(newValue, oldValue) {        
          // console.log("entry edited !!!");
          this.updateEntryLots();
      },
      deep: true,
    },
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    changeQuantity: function() {
      this.packagingQuantity = _.round(this.entry.quantity / this.entry.packaging.size, 10);
      this.packagingQuantityKey++;
    },
    changePackagingQuantity: function() {
      this.entry.quantity = _.round(this.packagingQuantity * this.entry.packaging.size, 10);
      this.quantityKey++;
    },
    selectItem: function(clearPackaging=false) {
      this.entry.item = this.availableItemsForCropping.find(obj => obj.id == this.entry.itemId);
      var storages = this.extraData.accountContext.allStorages || this.extraData.accountContext.allGreenhouses
      if (!this.entry.storageId && storages.length == 1) {
        this.entry.storageId = storages[0].id;
        this.selectStorage(); 
      }

      // console.log("this.entry.item.cropLimit", this.entry.item.cropLimit)
      if (this.entry.item.cropLimit != null || this.entry.item.cropLimit == 0) {
        this.entryAttributes.quantity.rules = [];
        this.entryAttributes.quantity.rules.push(this.requiredRule);
        this.entryAttributes.quantity.rules.push(this.minRequiredRule);
        let limitQuantity = _.round(this.entry.item.cropLimit, 2);
        // usado para contabilizar a quantidade já salva no edit
        if (this.isEdit) {
          limitQuantity = _.round(this.entry.item.cropLimit + this.originalEntry.quantity, 2);
        }
        this.entryAttributes.quantity.rules.push(this.maxValueRule(limitQuantity));
        this.entry.item.cropLimit = limitQuantity;
      }

      if (clearPackaging) {
        this.entry.packagingId = null;
      }
      // this.emptyLots();
      this.loadPackagings(); 
    },

    loadLots: function(){
      if(this.seedPlotOperation){
      this.$apollo
        .query({
          query: AVAILABLE_PLANT_LOTS_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId,
            trayId: this.entry.packagingId,
            operationTypeId: this.seedPlotOperation.operationTypeId,
          }
        })
        .then(response => {
          this.availablePlantLots = response.data.accountContext.availablePlantLotsForCroppingInSeedPlotOperation;
          console.log("avaipl", this.availablePlantLots);
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingListLoading = false));  
      }
      else {
        this.$apollo
        .query({
          query: AVAILABLE_PLANT_LOTS_FOR_EXECUTION_OPERATION_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId,
            operationTypeId: this.executionOperation.operationTypeId,
          }
        })
        .then(response => {
          this.availablePlantLots = response.data.accountContext.availablePlantLotsForCroppingInExecutionOperation;
          // console.log("avaipl", this.availablePlantLots);
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingListLoading = false)); 
      }
    },
    loadPackagings: function(){
      this.packagingListLoading = true;
      this.$apollo
        .query({
          query: PACKAGINGS_FOR_PRODUCED_PRODUCT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId,
          }
        })
        .then(response => {
          this.packagingList = response.data.accountGlobalSharedContext.allPackagingsOfProducedProductForCropping;

          // console.log("this.packagingList",this.packagingList);

          if (this.packagingList.length == 1 && !this.entry.packagingId) {
            this.entry.packagingId = this.packagingList[0].id;
            // this.entry.packaging = this.packagingList.find(obj => obj.id == this.entry.packagingId);
            this.selectPackaging();
          } else if (this.entry.packagingId) {
            this.selectPackaging();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingListLoading = false));
    },
    selectPackaging: function(empty = false) {
      this.entry.packaging = this.packagingList.find(obj => obj.id == this.entry.packagingId);
      if (this.entry.quantity) {
        this.changeQuantity();
      }
      if(!this.readOnly && empty){
        this.emptyLots();
      }
      this.loadLots();
    },
    //Removendo pois limpava quando nao devia !!!
    emptyLots: function(){
      // if(this.entry.entryMovementItemLotsAttributes){
      //   // console.log("bem", this.entry);
      //   // this.entry.entryMovementItemLotsAttributes.length = 0;
      //   while(this.entry.entryMovementItemLotsAttributes.length > 0){
      //     this.entry.entryMovementItemLotsAttributes.pop();
      //   }
      // }
    },
    selectStorage: function() {
      var storages = this.extraData.accountContext.allStorages || this.extraData.accountContext.allGreenhouses
      this.entry.storage = storages.find(obj => obj.id == this.entry.storageId);
    }, 
    clearFields: function() {
      this.forceRerender(this);
    },
    updateEntryLots: function(){      
      // console.log("addEntryLots");
      if(this.entry.entryMovementItemLotsAttributes){
        var reduced = 0;
        this.entry.entryMovementItemLotsAttributes.forEach((object)=>{
          // console.log("packaging quantity:", object.packagingQuantity);
          if (typeof object._destroy == 'undefined' || object._destroy == false){
            reduced+=parseFloat(object.packagingQuantity);
          }
        });

        this.packagingQuantity = reduced;
        this.packagingQuantityKey++;
        this.changePackagingQuantity();
      }
    },
    storageCreated: function(storage) {
      this.extraData.accountContext.allStorages.unshift(storage);
      this.entry.storageId = storage.id;
      this.entry.storage = storage;
    },
  }
};

const PACKAGINGS_FOR_PRODUCED_PRODUCT_QUERY = gql `
  query ($itemId: ID!) {
    accountGlobalSharedContext {
      allPackagingsOfProducedProductForCropping(itemId: $itemId) {
        id
        name
        unitName
        basicUnitName
        size
        text
      }
    }
  }
`;

const AVAILABLE_PLANT_LOTS_QUERY = gql `
  query ($itemId: ID!, $trayId: ID!, $operationTypeId: ID) {
    accountContext {
      availablePlantLotsForCroppingInSeedPlotOperation(itemId: $itemId, trayId: $trayId, operationTypeId: $operationTypeId)
    }
  }
`;

const AVAILABLE_PLANT_LOTS_FOR_EXECUTION_OPERATION_QUERY = gql `
  query ($itemId: ID!, $operationTypeId: ID) {
    accountContext {
      availablePlantLotsForCroppingInExecutionOperation(itemId: $itemId, operationTypeId: $operationTypeId)
    }
  }
`;


</script>

<style scoped></style>
